// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2fVUT","filesListContainer":"PosDisputesFiles_filesListContainer__2LSI8","filesButton":"PosDisputesFiles_filesButton__2jv3U"};